export enum ModuleType {
    RECURRING = "RECURRING"
}
